<template>
  <h1 class="mt-4">Page Not Found :-(</h1>

  <p>
    The page you are looking for is not found.
  </p>

  <p>
    Please check the URL and try again.
  </p>

  <p>
    <RouterLink :to="{ name: 'home' }" class="text-primary">Return to Home</RouterLink>
  </p>
</template>
